exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".swiper-box[_v-3dad789a]{width:100%;height:100%;margin:0 auto}.swiper-item[_v-3dad789a]{background-size:cover;background-position:top;background-repeat:no-repeat;height:0;padding-bottom:600px}#slider .container[_v-3dad789a]{background:transparent}@media (max-width:767px){.swiper-item[_v-3dad789a]{padding-bottom:166px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-3dad789a&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./assets/component/video_image_slider.vue
// module id = 298
// module chunks = 0